import { React, PropTypes, styled, useTheme, reduxConnect } from '../lib/imports';
import { useCdnUrl } from '../app/context/config';
import { Button, Heading, Image, ShadowBox, Text } from '../components';
import { useSelector } from 'react-redux';
import { setHeatStreakPanelToOpen } from '../ui/actions';

const Container = styled(ShadowBox)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacings.giga};
  height: 565px;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
`;

const CardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacings.bit};
`;

const NoChallengeTitle = styled(Heading)`
  flex-grow: 1;
  font-size: 28px;
  width: 360px;
  line-height: 1;
`;

const NoChallengeDescription = styled(Text)`
  line-height: 25px;
  text-align: center;
  padding: 6px 24px 12px 24px;
  span {
    display: block;
    margin-bottom: ${({ theme }) => theme.spacings.atom};
    font-size: ${({ theme }) => theme.typography.subHeadings.tera.fontSize};
    line-height: ${({ theme }) => theme.typography.subHeadings.tera.fontSize};
    padding-bottom: ${({ theme }) => theme.spacings.giga};
    sup {
      font-size: ${({ theme }) => theme.typography.headings.deca.fontSize};
    }
  }
`;

const NoChallengeButton = styled(Button)`
  min-width: 0;
`;

const NoChallengeImage = styled(Image)`
  width: 200px;
  margin: 16px 0 0 0;
`;

const NoChallengeCard = ({ handleHeatStreakPanelClick }) => {
  const { strings } = useSelector((state) => state);
  const noChallengeTitle = strings['challenges/nochallenge/title'];
  const noChallengeDescription = strings['challenges/nochallenge/description'];
  const noChallengeButtonText = strings['challenges/nochallenge/buttonText'];
  const noChallengeImage = '2024_HockeySticks.svg';

  const theme = useTheme();
  const cdnUrl = useCdnUrl();

  return (
    <Container background={`${theme.colors.headerBg}`}>
      <CardHeader>
        <NoChallengeTitle as='h4' noMarginTop noMarginBottom>
          {noChallengeTitle}
        </NoChallengeTitle>
      </CardHeader>
      <NoChallengeDescription size='tera'>{noChallengeDescription}</NoChallengeDescription>
      <NoChallengeButton variant='primary' onSelect={handleHeatStreakPanelClick} noMargin>
        <Text as='h4' size='peta' bold>
          {noChallengeButtonText}
        </Text>
      </NoChallengeButton>
      <NoChallengeImage src={`${cdnUrl}${noChallengeImage}`} />
    </Container>
  );
};

NoChallengeCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  background: PropTypes.string,
  title: PropTypes.string,
  dates: PropTypes.string,
  logosSrc: PropTypes.array,
  sponsorText: PropTypes.string,
  active: PropTypes.bool,
  noBadge: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleHeatStreakPanelClick: () => dispatch(setHeatStreakPanelToOpen()),
  };
};

export default reduxConnect(null, mapDispatchToProps)(NoChallengeCard);
